Ext.define('SA.lq.view.ExportWidget', {
    alias: 'widget.lq-export-widget',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-export-widget',
    width: 304,

    items: [
        {
            xtype: 'simple-container',
            cls: 'sa-export-widget-body',

            items: [
                {
                    xtype: 'load-mask',
                    itemId: 'loadMask',
                    spinnerSize: 'small'
                }, {
                    xtype: 'component',
                    cls: 'sa-beyond-limit-default-message',
                    hidden: true,
                    itemId: 'limitMessage',

                    html: [
                        '<svg class="sa-beyond-limit-default-message-svg"><use href="#sa-icon-warning"></use></svg>',
                        '<div>',
                            '<div class="sa-beyond-limit-default-message-primary-text">This export would exceed the ',
                            'maximum weekly or annual data export limits for one or more datasets.</div> For information ',
                            'about which datasets triggered this error, please <a href="#">click here</a>.',
                        '</div>'
                    ]
                }, {
                    xtype: 'simple-container',
                    cls: 'sa-export-widget-field-row',

                    items: [
                        {
                            xtype: 'component',
                            cls: 'sa-export-widget-field-label',
                            html: 'File format:',
                            width: 73
                        }, {
                            xtype: 'sa-radio-group',
                            cls: 'sa-export-widget-file-format-radio-group',
                            itemId: 'fileFormatRadioGroup',
                            disabled: true,

                            items: [
                                {boxLabel: 'Excel', value: 'xlsx', checked: true},
                                {boxLabel: 'CSV', value: 'csv'},
                                {boxLabel: 'DBF', value: 'zip'}
                            ]
                        }
                    ]
                }, {
                    xtype: 'simple-container',
                    cls: 'sa-export-widget-field-row',
                    margin: '17 0 0 0',

                    items: [
                        {
                            xtype: 'component',
                            cls: 'sa-export-widget-field-label',
                            html: 'Export to:',
                            width: 73
                        }, {
                            xtype: 'sa-toggle-switch',
                            checked: true,
                            cls: 'sa-export-widget-email-or-save-toggle-switch',
                            disabled: true,
                            itemId: 'deliveryTypeSwitch',
                            leftText: 'Email',
                            rightText: 'Save to computer'
                        }
                    ]
                }, {
                    xtype: 'container',
                    hidden: true,
                    itemId: 'emailSection',

                    defaults: {
                        labelAlign: 'top',
                        labelCls: 'sa-export-widget-field-label',
                        labelClsExtra: 'sa-export-widget-field-label-top',
                        margin: '17 0 0 0',
                        width: '100%'
                    },

                    items: [
                        {
                            xtype: 'sa-textfield',
                            allowBlank: false,
                            fieldLabel: 'Email address:',
                            itemId: 'emailAddress',
                            msgTarget: 'none',
                            vtype: 'email'
                        }, {
                            xtype: 'textarea',
                            fieldLabel: 'Message (optional):',
                            itemId: 'emailMessage'
                        }
                    ]
                }
            ]
        }, {
            xtype: 'simple-container',
            cls: 'sa-export-widget-footer',

            items: [
                {
                    xtype: 'sa-button',
                    text: 'Export',
                    disabled: true,
                    itemId: 'exportBtn',
                    ui: 'primary',
                    width: 118
                }, {
                    xtype: 'sa-button',
                    text: 'Cancel',
                    itemId: 'cancelBtn',
                    width: 118
                }
            ]
        }
    ],

    deliveryTypeSwitchValueIsDownload() {
        return this.getDeliveryTypeSwitchValue() === 'download';
    },

    deliveryTypeSwitchValueIsEmail() {
        return this.getDeliveryTypeSwitchValue() === 'email';
    },

    enableDeliveryTypeSwitch() {
        this.deliveryTypeSwitch.enable();
    },

    enableExportBtn() {
        this.setExportBtnEnabled(true);
    },

    enableFileFormatRadioGroup() {
        this.fileFormatRadioGroup.enable();
    },

    getDeliveryTypeSwitchValue() {
        return this.deliveryTypeSwitch.isChecked() ? 'download' : 'email';
    },

    getEmailAddressValue() {
        return this.emailAddressField.getValue();
    },

    getEmailMessageValue() {
        return this.emailMessageTextarea.getValue();
    },

    getFileFormatRadioGroupValue() {
        return this.fileFormatRadioGroup.getValue();
    },

    hasValidEmailAddressValue() {
        return this.emailAddressField.isValid();
    },

    hideLoadMask() {
        this.loadMask.hide();
    },

    setEmailSectionVisible(visible) {
        this.emailSection.setVisible(visible);
        this.updateLayout();
    },

    setExportBtnEnabled(enabled) {
        this.exportBtn.setEnabled(enabled);
    },

    setLimitMessageLinkClickCb(cb) {
        this.limitMessageEl.el.down('a').on('click', cb, null, {preventDefault: true});
    },

    showLimitMessage() {
        this.limitMessageEl.show();
        this.updateLayout();
    }
});